import { render, staticRenderFns } from "./RolePrivilegeList.vue?vue&type=template&id=75ac85e6&"
import script from "./RolePrivilegeList.vue?vue&type=script&lang=js&"
export * from "./RolePrivilegeList.vue?vue&type=script&lang=js&"
import style0 from "./RolePrivilegeList.vue?vue&type=style&index=0&id=75ac85e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports